// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VCharts from 'v-charts'
import App from './App'
import router from './router'
import axios from 'axios'
import VueResource from 'vue-resource'
import store from './store'
import 'lib-flexible/flexible'

import Vant, { Toast, Dialog } from 'vant'
import 'vant/lib/index.css'
import { setClientData, setUserData, setProjectData } from '@/utils/user'
import { getUserInfoApi, getProjectDetailApi } from '@/api/common_api'
import { getProjectId } from './utils/user'
import wx from 'weixin-js-sdk'
import './assets/scss/font.css'
// import jq from 'jquery'
import { Table, TableColumn } from 'element-ui';

// 手机端调试
import Vconsole from 'vconsole'

// 当前设备
import device from 'current-device'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import VueCropper from 'vue-cropper'
// 当前环境
const uni = require("../static/js/uni-webview.js")
uni.getEnv(function(res) {
  Vue.prototype.$currentEnv = res
});
// 当前环境
// 是否是全面屏
const rate = window.screen.height / window.screen.width
let limit = window.screen.height === window.screen.availHeight ? 1.8 : 1.65
let isFullScreen = false
if (rate > limit) {
  isFullScreen = true
}
Vue.prototype.$isFullScreen = isFullScreen
// 是否是全面屏
Vue.use(VueCropper)
// 设置cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// const device = require('current-device').default
// Vue
Vue.use(VCharts)
Vue.use(Vant)
// Vue.use(jq) // 引入jq
Vue.use(Table);  // element-ui的Table组件
Vue.use(TableColumn);  // element-ui的TableColumn组件
// 阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false
// 开启debug模式
Vue.config.debug = true
if (process.env.NODE_ENV !== 'production') {
  const vConsole = new Vconsole()
  Vue.use(vConsole)
}
// 动态更改title
Vue.use(require('vue-wechat-title'))

// 全局注册
Vue.use(Dialog)

// 全局初始化 Axios
Vue.prototype.$axios = axios
// 全局初始化 微信jssdk
Vue.prototype.$wx = wx
// 全局初始化
Vue.prototype.$device = device
// ajax异步
Vue.use(VueResource)
// 交互兼容json对象
Vue.http.options.emulateJSON = true
// 全局获取小程序环境判断
Vue.prototype.isMiniProgram = false
// 定义全局eventBus
// Vue.prototype.$EventBus = new Vue()

// window.eventBus = new Vue()

// // 解决跳转到当前路由报错问题
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch((err) => err)
// }
//Alloyfinger手势插件
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'

Vue.use(AlloyFingerPlugin,{
  AlloyFinger
})

wx.miniProgram.getEnv((res) => {
  console.log('进入方法')
  if (res && res.miniprogram) { // 小程序环境 res.miniprogram是true/false
    console.log('是小程序环境')
    Vue.prototype.isMiniProgram = true
  }
})

/* eslint-disable no-new */
var init = () => {
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    data: {
      event: new Vue()
    }
  })
}
// 入口方法
var main = () => {
  let query = getQuery()
  Vue.prototype.$source = query.source
  if (Object.keys(query).length > 0) {
    if (query.accessToken) {
      setClientData(query) // 这个方法有问题，假如参数里面没有传token，刷新当前页面，会导致该页面接口请求失败
    }
    //门禁设备不需要获取个人信息
    if (window.location.href.indexOf("/info/") < 0  && window.location.href.indexOf('center_invitation') < 0 )  {
      getUserInfo()
    } else { 
      init()
    }
  } else {
    // 为啥没有带参数的时候 也执行这个？
    // setClientData(query)
    init()
  }
}
// 获取初始传参
var getQuery = function () {
  var indexof = window.location.href.indexOf('?')
  var lastindexof = window.location.href.lastIndexOf('#/')
  var content = ''
  if (lastindexof < indexof) {
    content = window.location.href.substring(indexof)
  } else if (lastindexof > indexof) {
    content = window.location.href.substring(indexof, lastindexof)
  }
  var query = {}
  if (content.length > 0) {
    var array = content.substr(1).split('&')
    array.forEach(element => {
      let kv = element.split('=')
      if (kv.length === 2) {
        query[kv[0]] = kv[1]
      }
    })
  }
  return query
}

// 获取用户信息
var getUserInfo = function () {
  getUserInfoApi().then((res) => {
    if (res.code === 1000) {
      setUserData(res.result)
      getProjectDetail()
    } else if (window.location.href.indexOf('center-login') > 0) {
      this.$router.replace({ name: "登录页" });
    } 
  }).catch(() => {
    init()
    // Toast('获取用户信息失败')
  })
}
// 获取项目详情
var getProjectDetail = function () {
  var projectId = getProjectId()
  // 打开后，已缓存项目详情数据就不在请求
  // var projectCacheData = getProjectData()
  // if (projectCacheData !== undefined && projectCacheData !== null && projectCacheData.id === projectId) {
  //   // 说明已有该项目的缓存数据
  //   init()
  //   return
  // }
  var params = {'id': projectId}
  getProjectDetailApi(params).then((res) => {
    if (res.code === 1000) {
      setProjectData(res.result)
      init()
    } else {
      init()
      // Toast(res.message) // 不要在这里toast，可以console，不然页面刷新，这个接口会报异常。。。
    }
  }).catch(() => {
    init()
    Toast('获取项目信息失败')
  })
}
// 调用入口方法
main()

// Vue.directive('title', {//单个修改标题
//   inserted: function (el, binding) {
//     document.title = el.dataset.title
//   }
// })


// WEBPACK FOOTER //
// ./src/main.js